import { SSText } from "src/components/base/components/SSText";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";
import { routes } from "./routes";
import React from "react";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { global_config } from "./global_config";
import { openPdfInNewTab } from "src/utils/utils";

export type TGlobalLanguages = {
  TERMS_AND_CONDITION: () => React.ReactNode;

  PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => React.ReactNode;
    DESCRIPTION: () => React.ReactNode;
  };
  GROUP_INVITE_PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => React.ReactNode;
    DESCRIPTION: () => React.ReactNode;
  };
  ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => React.ReactNode;
    DESCRIPTION: () => React.ReactNode;
  };
};

export const globalLanguages: TGlobalLanguages = {
  TERMS_AND_CONDITION: () => {
    const theme = useSSTheme();
    const { md: mdUp } = useCssMediaQuery("up");
    const router = useRouterExt();
    return (
      <>
        By purchasing you understand that you are agreeing to a monthly
        subscription. It will renew each month unless you cancel during the
        defined opt-out period. Tickets are non-transferable and not eligible
        for resale.
        {!mdUp ? (
          <>
            <br />
            <br />
          </>
        ) : (
          " "
        )}
        You also agree to receive SMS alerts regarding ticket delivery and agree
        to the{" "}
        <span
          onClick={(ev) => {
            ev?.preventDefault();
            ev.stopPropagation();
            openPdfInNewTab(global_config.TERMS_AND_CONDITIONS_PDF_URL);
          }}
          style={{
            cursor: "pointer",
            color: theme.colors.teamPrimary,
            textDecoration: "underline",
            textUnderlineOffset: "0.2em",
            fontWeight: "bold",
          }}
        >
          Terms and Conditions
        </span>{" "}
        and{" "}
        <span
          onClick={(ev) => {
            ev?.preventDefault();
            ev.stopPropagation();
            openPdfInNewTab(global_config.PRIVACY_POLICY_PDF_URL);
          }}
          style={{
            cursor: "pointer",
            color: theme.colors.teamPrimary,
            textDecoration: "underline",
            textUnderlineOffset: "0.2em",
            fontWeight: "bold",
          }}
        >
          Privacy Policy
        </span>
        .
      </>
    );
  },

  PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => "You’re all set to experience the action!",
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Friends don’t leave friends behind.{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                Invite your friends
              </span>
            </u>
          </b>{" "}
          and enjoy games together.
        </>
      );
    },
  },

  GROUP_INVITE_PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => {
      return `You’re all set to join in on the action with your group!`;
    },
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          You’ll be seated next to{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                your group
              </span>
            </u>
          </b>{" "}
          when you Check In for the same event.
        </>
      );
    },
  },

  ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
    TITLE: () => "Purchase Confirmed!",
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Thank you for your purchase!{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                Invite your friends
              </span>
            </u>
          </b>{" "}
          and enjoy games together.
        </>
      );
    },
  },
};
